// يسجّل وقت الاستماع (الإذاعة والتلاوات) لإحصائيات القراءة.
//
// في أندرويد حالة المشغّل الأصلي تشمل الإذاعة والتلاوة معاً؛ وفي المتصفح
// حالة الإذاعة من السياق. يُحفظ كل ١٥ ثانية فلا يضيع إلا القليل إن أُغلق التطبيق.

import { useEffect, useRef } from 'react';
import { hasNativePlayer, onNativeState } from '../utils/nativePlayer';
import { logListening } from '../utils/readingLog';

const FLUSH_MS = 15000;

export function useListeningLog(webPlaying) {
  const playing = useRef(false);
  const since = useRef(0);
  const native = hasNativePlayer();

  useEffect(() => {
    const set = (on) => {
      const now = Date.now();
      if (playing.current) logListening((now - since.current) / 1000);
      playing.current = on;
      since.current = now;
    };
    const unsub = native ? onNativeState((st) => set(Boolean(st?.playing))) : null;
    const flush = setInterval(() => playing.current && set(true), FLUSH_MS);
    return () => {
      clearInterval(flush);
      unsub?.();
      set(false);
    };
  }, [native]);

  useEffect(() => {
    if (native) return;
    const now = Date.now();
    if (playing.current) logListening((now - since.current) / 1000);
    playing.current = Boolean(webPlaying);
    since.current = now;
  }, [webPlaying, native]);
}
